// Dijital saat widget'ı — Blazor ClockWidget.
import { useEffect, useState } from 'react';

export function ClockWidget() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="flex h-full flex-col items-center justify-center">
      <div className="text-fg text-3xl font-semibold tabular-nums sm:text-4xl">{now.toLocaleTimeString('tr-TR')}</div>
      <div className="text-fg-muted text-sm">{now.toLocaleDateString('tr-TR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</div>
    </div>
  );
}
